import React from 'react';
import step1 from '../../sass/images/product-step-1.png';
import step2 from '../../sass/images/product-step-2.png';
import step3 from '../../sass/images/product-step-3.png';
import step4 from '../../sass/images/product-step-4.png';
import ProductStep from '../ProductStep/index';
import './Product.scss';




const isEven = number => number % 2 === 0

const renderSteps = data => data.map((item,index) => 
  isEven(index) ?
  <ProductStep {...item} number={index + 1} direction="right"/> :
  <ProductStep {...item} number={index + 1} direction="left"/>
)

const mountContent = contentText => {
  const imagesArr = [step1, step2, step3, step4]
  return contentText.map((item, index) => {
    return {
      title: item.title,
      text: item.text,
      image: imagesArr[index]
    }
  })
}

const ProductBox = (props, context) => {
  const content = mountContent(props.content || [])
  return (
    <div className="container">
      <div className="product-box">
          <h2>Como funciona?</h2>
          <p className="subtitle">O Talkative é simples de usar, veja só:</p>

        <div className="grid-center steps-container">
          { renderSteps(content) }
        </div>
      </div>
    </div>
  );
};

export default ProductBox;



// WEBPACK FOOTER //
// ./src/components/Box/Product.js